"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setup = require("./_setup.js");

var _tagTester = _interopRequireDefault(require("./_tagTester.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
var _default = _setup.nativeIsArray || (0, _tagTester.default)('Array');

exports.default = _default;